import { FC } from "react"
import ViewSettings from "./ViewSettings"
import ViewSettingsFairValueEvaluationModal from "./ViewSettingsFairValueEvaluationModal"
import ViewSettingsFairValueEvaluationModel from "models/ViewSettingsFairValueEvaluation"

interface IViewSettingsFairValueEvaluationProps {
    viewSettings: ViewSettingsFairValueEvaluationModel
    setViewSettings(viewSettings: ViewSettingsFairValueEvaluationModel): void
}

const ViewSettingsFairValueEvaluation: FC<IViewSettingsFairValueEvaluationProps> = ({
    viewSettings,
    setViewSettings,
}) => {
    return (
        <ViewSettings
            isDefault={viewSettings.isDefault}>
            {onClose => <ViewSettingsFairValueEvaluationModal
                    viewSettings={viewSettings}
                    onClose={onClose}
                    onSave={setViewSettings}
                />
            }
        </ViewSettings>
    )
}

export default ViewSettingsFairValueEvaluation
